import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Alert,
} from "reactstrap";
import Draggable from "react-draggable";

import { UploadFile } from "./utils/DataFetch";
import { GetCookie } from "./utils/Common";

const moment = require("moment");

import Logo from "../images/logo1.png";

export class WorkOrderIntFormEndTimeComment extends Component {
  static displayName = WorkOrderIntFormEndTimeComment.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    const rawTime = props.finishTimeString || props.jobmodel.FinishTimeString || "";
    const finishTimeDisplay = rawTime
      ? moment(rawTime, "HH:mm").format("h:mm A")
      : "";

    this.state = {
      alert: props.alert,

      finishTimeDisplay,
      jobmodel: props.jobmodel,
      isSubmitting: false,
      model: {
        EventType: "insert",
        JobHistoryId: null,
        JobId: props.jobmodel.JobId,
        JobHistoryName: "",
        Description: "",
        Contact: "",
        FileLocation: "",
        FileNames: [],
        JobHistoryType: "Int Finish",
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        FormFiles: [],
      },
      deltaPosition: { x: 0, y: 0 },
    };

    //
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleRemoveFile = this.handleRemoveFile.bind(this);
    //
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
  }

  componentDidMount() {}

  handleSubmitClick() {
    if (this.state.isSubmitting) {
      return;
    }

    let model = { ...this.state.model };
    const description = (model.Description || "").trim();

    if (description === "") {
      this.setState({
        alert: {
          color: "warning",
          message: "Description field must not be blank.",
          isOpen: true,
        },
      });
      return;
    }

    if (model.EventType === "insert") {
      model.CreateByUserId = this.user.userid;
    }

    var formData = new FormData();
    formData.append("EventType", model.EventType);
    formData.append("JobHistoryId", model.JobHistoryId);
    formData.append("JobId", model.JobId);
    formData.append("JobHistoryName", model.JobHistoryName);
    formData.append("Description", "Comment: " + description);
    formData.append("Contact", model.Contact);
    formData.append("ContactEmail", model.ContactEmail);
    formData.append("FileLocation", model.FileLocation);
    formData.append("FileName", model.FileNames.join(","));
    formData.append("JobHistoryType", model.JobHistoryType);
    formData.append("CreateDateTime", model.CreateDateTime);
    formData.append("CreateByUserId", model.CreateByUserId);
    formData.append("UpdateByUserId", model.UpdateByUserId);
    formData.append("UpdateDateTime", model.UpdateDateTime);
    model.FormFiles.forEach((file) => formData.append("FormFile", file));

    this.setState({ isSubmitting: true });

    UploadFile("/savejobhistory", this.user.token, formData)
      .then((data) => {
        const isSuccess = data === "Success";
        if (isSuccess) {
          const fileCount = model.FormFiles.length;
          const fileInfo = fileCount === 1
            ? `\nFile: ${model.FileNames[0]}`
            : fileCount > 1
            ? `\nFiles: ${model.FileNames.join(", ")}`
            : "";
          window.confirm(
            `Your end time and comment have been saved successfully.\n\nEnd Time: ${this.state.finishTimeDisplay}\nComment: ${description}${fileInfo}`
          );
        }
        this.props.handleSaveEventSuccess({
          message: data,
          modal: isSuccess ? false : true,
          modalEndTimeComment: isSuccess ? false : true,
          color: isSuccess ? "success" : "warning",
          model: model,
        });
      })
      .catch(() => {
        this.setState({
          alert: {
            color: "warning",
            message: "Unable to submit comment. Please try again.",
            isOpen: true,
          },
        });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }

  handleFileChange(e) {
    const newFiles = Array.from(e.target.files);
    let model = { ...this.state.model };
    model.FormFiles = [...model.FormFiles, ...newFiles];
    model.FileNames = model.FormFiles.map((f) => f.name);
    this.setState({ model });
    // Reset input so the same file can be added again if needed
    e.target.value = "";
  }

  handleRemoveFile(index) {
    let model = { ...this.state.model };
    model.FormFiles = model.FormFiles.filter((_, i) => i !== index);
    model.FileNames = model.FormFiles.map((f) => f.name);
    this.setState({ model });
  }

  handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;

    this.setState({ model: model }, () => {});
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag(e, ui) {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const isMobile = window.innerWidth < 768;

    return (
      <div>
        <Draggable
          handle=".workorder-int-endtime-comment-handle"
          onDrag={this.handleDrag}
          disabled={isMobile}
          {...dragHandlers}
        >
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              width: 'min(400px, 95vw)',
              transform: isMobile ? undefined : `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
            }}
          >
            <ModalHeader className="workorder-int-endtime-comment-handle handle">
              Comment
            </ModalHeader>
            <ModalBody>
            <div>
              <Row>
                <Col style={{ textAlign: "center" }}>
                  <Alert
                    color={this.state.alert.color}
                    isOpen={this.state.alert.isOpen}
                  >
                    {this.state.alert.message}
                  </Alert>
                </Col>
              </Row>
              <Row>
                <Col>
                  <center>
                    <img src={Logo} alt="Logo" />
                  </center>
                </Col>
              </Row>
              <Row>
                <Col>
                  <center>
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Please Call 800-522-2320 if you have any questions.
                    </p>
                  </center>
                </Col>
              </Row>
              <Row>
                <Col>
                  <textarea
                    name="Description"
                    className="form-control"
                    placeholder="Enter comment (mileage, parking, etc.)"
                    onChange={this.handleChange}
                  ></textarea>
                </Col>
              </Row>
              <Row>
                <Col>
                  <center>
                    <p>
                      <small>Upload File or Photo</small> <br />
                      <input
                        name="fileUpload"
                        type="file"
                        multiple
                        className="form-control"
                        ref={(ref) => (this.fileUpload = ref)}
                        onChange={this.handleFileChange}
                      ></input>
                    </p>
                  </center>
                  {this.state.model.FormFiles.length > 0 && (
                    <ul style={{ paddingLeft: "1.2rem", marginBottom: "0.5rem" }}>
                      {this.state.model.FormFiles.map((file, i) => (
                        <li key={i} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                          <small style={{ wordBreak: "break-all" }}>{file.name}</small>
                          <button
                            type="button"
                            onClick={() => this.handleRemoveFile(i)}
                            style={{ background: "none", border: "none", color: "red", cursor: "pointer", padding: 0, lineHeight: 1 }}
                            aria-label={`Remove ${file.name}`}
                          >
                            ✕
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <center>
                    <Button
                      color={"success"}
                      size="sm"
                      onClick={this.handleSubmitClick}
                    >
                      {" "}
                      {this.state.isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                    <Button
                      color={"danger"}
                      onClick={this.props.setModal}
                      size="sm"
                    >
                      {" "}
                      Cancel
                    </Button>
                  </center>
                </Col>
              </Row>
              <hr />
            </div>
            </ModalBody>
            {/*<ModalFooter>*/}

            {/*</ModalFooter>*/}
          </Modal>
        </Draggable>
      </div>
    );
  }
}
